<div class="home-sidebar">
  <ul class="home-sidebar__pages">
    @for (link of links(); track link) {
      @let upperLink = link.label.slice(12).toUpperCase();
      <li class="home-sidebar__link-wrapper" [ngClass]="{ 'active-li': activeLink.isActive }">
        <app-icon
          class="icon"
          [ngClass]="{ 'active-icon': activeLink.isActive }"
          [icon]="getIcon(activeLink.isActive ? upperLink + 'ACTIVE' : upperLink)"
        />
        <a
          [routerLink]="link.path"
          routerLinkActive="active"
          #activeLink="routerLinkActive"
          [ngClass]="{ active: activeLink.isActive }"
          class="home-sidebar__refs"
        >
          {{ link.label | translate }}
        </a>
      </li>
    }
  </ul>
  <div
    class="home-sidebar__settings"
    [class.home-sidebar__settings--active]="settingsActive.isActive"
  >
    <app-icon
      class="icon"
      [ngClass]="{ 'active-icon': settingsActive.isActive }"
      [icon]="settingsActive.isActive ? IconName.SETTINGSACTIVE : IconName.SETTINGS"
    />
    <a
      [routerLink]="appRoutes.SETTINGS"
      routerLinkActive="active"
      #settingsActive="routerLinkActive"
      [ngClass]="{ active: settingsActive.isActive }"
      class="home-sidebar__refs"
    >
      {{ 'homeSidebar.settings' | translate }}
    </a>
    <div></div>
  </div>
</div>
